<template>
  <div
    id="Modal"
    class="slb-modal"
    data-module="modal"
  >
    <div class="slb-modal__content">
      <div class="slb-modal__content__header">
        <button
          class="btn-close"
          @click="close"
        >
          <IconClose />
        </button>
        <h3 class="tit tit-m">
          {{ title }}
        </h3>
      </div>

      <div class="slb-modal__content__text">
        <div class="custom-scrollbar">
          <p v-html="text"></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import IconClose from '@/components/icons/IconClose.vue';

export default {
  name: 'Modal',
  components: {
    IconClose,
  },
  props: {
    instanceId: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    text: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      showModal: false,
    };
  },
  methods: {
    close() {
      this.$emit('close');
    },
  },
};
</script>

<style scoped lang="scss">
.slb-modal {
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  background-color: rgba($lb-dark-gray, 0.4);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;

  &__content {
    margin: 0;
    max-height: 90%;
    max-width: 800px;
    width: 90%;
    padding: 60px;
    background-color: $lb-white;
    text-align: left;

    &__header {
      width: 100%;
      position: relative;

      .btn-close {
        position: absolute;
        top: -30px;
        right: -30px;
        cursor: pointer;
        color: $lb-black;
      }
    }

    &__text {
      line-height: 26px;
      color: $lb-light-gray;
      font-size: $size-small;
      margin-top: 40px;

      p {
        padding-right: 15px;
      }
    }

    .custom-scrollbar {
      max-height: 45vh;
    }
  }
}

@include media-breakpoint-down(sm) {
  .slb-modal {
    &__content {
      padding: 9.375vw;

      &__header {
        .btn-close {
          .icon svg {
            width: 18px;
            height: 18px;
          }
        }
      }

      &__text {
        margin-top: 20px;
      }
    }
  }
}
</style>
